export const ValidateEmailDirective = angular
    .module('checkout.directives.validateEmail', [])
    .directive('validateEmail', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, elm, attrs, ngModel) => {
                ngModel.$validators.validEmail = (modelValue) => {
                    return modelValue && /.+@.+\.[^\s]+/.test(modelValue);
                };
                ngModel.$validators.validLength = (modelValue) => {
                    return modelValue && modelValue.length < 75;
                };
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/validateEmail.js